export default __webpack_public_path__ + "static/media/statistic.29ee722a.svg";